import { SxProps } from '@mui/material';

export const textFieldContainerSx = {
	display: 'flex',
	alignItems: 'flex-start',
	gap: 1,
};

export const formHelperPropsSx = {
	marginTop: '5px',
	marginLeft: '0',
};

export const textFieldSx = {
	flexGrow: 1,
	mt: 1,
};

export const inputPropsSx = ({ hasError }: { hasError: boolean }): SxProps => ({
	'& input': {
		paddingLeft: '10px',
		paddingRight: '5px',
	},
	'&.Mui-focused .MuiOutlinedInput-notchedOutline': {
		borderColor: 'grey.50',
	},
	'&:hover .MuiOutlinedInput-notchedOutline': {
		borderColor: 'grey.50',
	},
	'.MuiOutlinedInput-notchedOutline': {
		borderColor: 'grey.50',
	},
	'& .MuiOutlinedInput-notchedOutline': {
		border: hasError ? 'none' : undefined,
		borderRight: hasError ? '2px solid red' : undefined,
		borderBottom: hasError ? '2px solid red' : undefined,
		borderRadius: 0,
	},
});

export const iconButtonSx = ({ focusedSearchBar }: { focusedSearchBar: boolean }): SxProps => ({
	minWidth: 0,
	padding: 0,
	backgroundColor: 'transparent',
	border: 'none',
	boxShadow: 'none',
	color: focusedSearchBar ? 'primary.main' : '',
	'&:hover': {
		border: 'none',
		boxShadow: 'none',
	},
	'&:focus': {
		outline: 'none',
	},
});
